import { useMutation, useQueryClient } from '@tanstack/react-query';

import { disableExpertMutation as disableExpertMutationFn } from '../api/mutations/disableExpertMutation';
import { graphQLClient } from '@/client/services/api/clients/graphqlClient';
import { useToastStore } from '@/client/services/state/toastStore';
import { useTranslation } from 'react-i18next';

export const useDisableExpert = () => {
  const { t } = useTranslation();
  const { setToast } = useToastStore();

  const queryClient = useQueryClient();

  const disableExpertMutation = useMutation({
    mutationFn: async (expertId: string) => {
      const data = await graphQLClient.request(disableExpertMutationFn, { expertId });

      return data.disableExpert;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['listExperts'] });

      setToast({
        show: true,
        status: 'success',
        title: t('admin.aiAgent.experts.disableSuccess'),
      });
    },
    onError: () =>
      setToast({
        show: true,
        status: 'error',
        title: t('admin.aiAgent.experts.disableError'),
      }),
  });

  return {
    disableExpertMutation,
  };
};
